const getSeconds = (timeString: string): number => {
  const timeParts = timeString.split(":");
  if (timeParts.length === 3) {
    // Full format: HH:MM:SS
    const hours = parseInt(timeParts[0], 0);
    const minutes = parseInt(timeParts[1], 0);
    const seconds = parseFloat(timeParts[2]);
    return (hours * 3600) + (minutes * 60) + seconds;
  }

  if (timeParts.length === 2) {
    // Short format: MM:SS
    const minutes = parseInt(timeParts[0], 0);
    const seconds = parseFloat(timeParts[1]);
    return (minutes * 60) + seconds;
  }
  throw new Error(`Invalid time format: ${timeString}`);
};

const parseTimes = (timesString: string): { startTime: number; endTime: number } => {
  let parsed = timesString.split(" --> ");
  if (parsed.length !== 2) {
    parsed = timesString.split("--> ");
  }
  return { startTime: getSeconds(parsed[0]), endTime: getSeconds(parsed[1]) };
};

export default parseTimes;
